import React from 'react';
import { getColor } from '../Colors/Colors';
import './Icon.css';

export type IconName = 
    | 'close'
    | 'add'
    | 'refresh'
    | 'edit'
    | 'search'
    | 'user'
    | 'info'
    | 'alert'
    | 'question'
    | 'idea'
    | 'trash'
    | 'book'
    | 'home'
    | 'menu'
    | 'settings'
    | 'dots'
    | 'gentle'
    | 'calendar-clock'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'chevron-down'
    | 'drag'
    | 'adjustments'
    | 'sparkles'
    | 'check';

interface IconProps {
    name: IconName;
    size?: 'small' | 'large';
    color?: string;
    colorVariant?: 'primary-green' | 'light-green' | 'dark-green' | 'white' | 'black' | 'light-gray' | 'dark-gray' | 'gray' | 'warning-yellow' | 'warning-red' | 'pastelle-yellow' | 'pastelle-red' | 'pastelle-gray' | 'pastelle-blue';
    className?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}

// Icon SVG paths for all 25 icons
const iconPaths: Record<IconName, string> = {
    'close': 'M18 6l-12 12 M6 6l12 12',
    'add': 'M12 5l0 14 M5 12l14 0',
    'refresh': 'M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4 M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4',
    'edit': 'M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4 M13.5 6.5l4 4',
    'search': 'M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0 M21 21l-6 -6',
    'user': 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0 M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855',
    'info': 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0 M12 9h.01 M11 12h1v4h1',
    'alert': 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0 M12 9v4 M12 16v.01',
    'question': 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0 M12 16v.01 M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483',
    'idea': 'M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7 M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3 M9.7 17l4.6 0',
    'trash': 'M4 7l16 0 M10 11l0 6 M14 11l0 6 M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12 M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3',
    'book': 'M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z M12 5v16 M7 7h1 M7 11h1 M16 7h1 M16 11h1 M16 15h1',
    'home': 'M5 12l-2 0l9 -9l9 9l-2 0 M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7 M10 12h4v4h-4z',
    'menu': 'M4 6l16 0 M4 12l16 0 M4 18l16 0',
    'settings': 'M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0',
    'dots': 'M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
    'gentle': 'M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572 M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25 M12.5 15.5l2 2 M15 13l2 2',
    'calendar-clock': 'M10.5 21h-4.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3 M16 3v4 M8 3v4 M4 11h10 M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0 M18 16.5v1.5l.5 .5',
    'chevron-left': 'M15 6l-6 6l6 6',
    'chevron-right': 'M9 6l6 6l-6 6',
    'chevron-up': 'M6 15l6 -6l6 6',
    'chevron-down': 'M6 9l6 6l6 -6',
    'drag': 'M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0 M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0',
    'adjustments': 'M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M4 6l8 0 M16 6l4 0 M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M4 12l2 0 M10 12l10 0 M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0 M4 18l11 0 M19 18l1 0',
    'sparkles': 'M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z',
    'check': 'M5 12l5 5l10 -10'
};

const Icon: React.FC<IconProps> = ({
    name,
    size = 'small',
    color,
    colorVariant,
    className,
    onClick,
    style
}) => {
    const iconClass = `icon icon-${name} icon-${size}`;
    const combinedClassName = `${iconClass} ${className || ''}`.trim();
    
    // Use colorVariant if provided, otherwise use color prop
    const iconColor = colorVariant ? getColor(colorVariant) : color;

    return (
        <svg
            className={combinedClassName}
            style={{ color: iconColor, ...style }}
            onClick={onClick}
            role="img"
            aria-label={name}
            viewBox="0 0 24 24"
        >
            <path d={iconPaths[name]} />
        </svg>
    );
};

export default Icon; 